import React, { useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import styled, { keyframes } from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
  const { login } = useContext(AuthContext); // ✅ context API
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("http://localhost:5000/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(" Login successful!");
        login(data.user); // ✅ save { name, email, _id } to context/localStorage
        navigate("/UserProfile");
      } else {
        toast.error(data.error || "❌ Login failed");
      }
    } catch (err) {
      console.error("❌ Error during login:", err);
      toast.error("❌ Something went wrong. Please try again later.");
    }
  };

  return (
    <Container>
      <h2>Login</h2>
      <form onSubmit={handleLogin}>
        <Label>Email</Label>
        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <Label>Password</Label>
        <Input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <Button type="submit">Login</Button>
      </form>

      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
        style={{ width: "100%", boxSizing: "border-box" }}
      />

      <Footer>
        You have not registered yet?{" "}
        <Link to="/RegistrationForm">Registration</Link>
      </Footer>
    </Container>
  );
};

export default Login;

// Animation
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Styled Components
const Container = styled.div`
  max-width: 500px;
  margin: 4rem auto;
  padding: 2rem;
  background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  border: 1px solid #1f1f21;
  animation: ${fadeIn} 0.5s ease;

  h2 {
    color: #e6e6e6;
    margin-bottom: 1.5rem;
    text-align: center;
  }
`;

const Label = styled.label`
  display: block;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  color: #e6e6e6;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border: 1px solid #1f1f21;
  background-color: transparent;
  color: #e6e6e6;
  border-radius: 4px;
  text-transform: none;

  &:focus {
    border-color: #3f51ff;
    outline: none;
  }
`;

const Button = styled.button`
  background: linear-gradient(90deg, #194bfd 0%, #ad13fb 100%);
  color: #ffffff;
  transition: all 0.3s ease;
  cursor: pointer;
  padding: 0.75rem 1.5rem;
  border: none;
  margin-top: 1rem;
  border-radius: 4px;

  width: 100%;
  font-weight: bold;

  &:hover {
    background-color: #5a189a;
    color: #ffffff;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(90, 24, 154, 0.5);
  }
`;

const Footer = styled.div`
  text-align: center;
  margin-top: 1.5rem;
  color: #aaa;

  a {
    color: #4e9eff;
    text-decoration: none;
    font-weight: bold;

    &:hover {
      text-decoration: underline;
    }
  }
`;
